import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const itemHelpers = createMultiStyleConfigHelpers(['icon', 'link']);

const SidebarItemTheme = itemHelpers.defineMultiStyleConfig({
  baseStyle: {
    icon: {
      marginLeft: '32',
      marginRight: '16',
    },
    link: {
      _active: {
        bg: 'neutral.93',
      },
      _hover: {
        bg: 'neutral.95',
      },
      alignItems: 'center',
      color: 'purple.10',
      display: 'flex',
      flexShrink: '0',
      userSelect: 'none',
    },
  },
  variants: {
    disabled: {
      link: {
        _active: { bg: 'unset' },
        _hover: { bg: 'unset' },
        color: 'neutral.80',
        cursor: 'not-allowed',
      },
    },
    selected: {
      icon: {
        color: 'purple.50',
      },
      link: {
        '&::after': {
          background: 'purple.50',
          borderRadius: '0px 2px 2px 0px',
          content: "''",
          display: 'block',
          height: '100%',
          position: 'absolute',
          right: '0px',
          top: 'calc(50% - var(--sizes-48)/2)',
          transform: 'matrix(-1, 0, 0, 1, 0, 0)',
          width: '2px',
        },
        _active: {
          bg: 'purple.93',
        },
        _hover: {
          bg: 'purple.93',
        },
        bg: 'purple.95',
        fontWeight: 'semibold',
      },
    },
  },
});

export default SidebarItemTheme;
